import { getSelTotalCard } from '../../../api/order'
import { set_remaind_price } from '../../mutations-type'

export default {
  state: () => ({
    remaindPrice: 0
  }),
  mutations: {
    [set_remaind_price](state, remaindPrice) {
      state.remaindPrice = remaindPrice
    }
  },
  actions: {
    fetchRemaindPriceAction(context, payload = { tenantId: localStorage.getItem('tenantId') }) {
      return new Promise(async (resolve, reject) => {
        const { data } = await getSelTotalCard(payload)

        // 4.修改state数据
        context.commit(set_remaind_price, data.remaindPrice)

        resolve(data.remaindPrice)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order/index.js